var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-select", {
        staticClass: "w-md-25 w-sm-100 mb-4",
        attrs: {
          loading: false,
          options: _vm.specialtyOptions,
          label: _vm.$i18nHelpers.normalizeProp("name"),
          valueProp: "id",
          placeholder: _vm.$t("filterSpe")
        },
        on: {
          change: function($event) {
            return _vm.load()
          }
        },
        model: {
          value: _vm.table.filters.specialtyId,
          callback: function($$v) {
            _vm.$set(_vm.table.filters, "specialtyId", $$v)
          },
          expression: "table.filters.specialtyId"
        }
      }),
      _vm._v(" "),
      _c("paginated-table", {
        attrs: {
          fields: _vm.table.fields,
          items: _vm.appointments,
          "empty-text": _vm.$t("appointment-history.not-found"),
          stacked: _vm.stacked
        },
        scopedSlots: _vm._u(
          [
            !_vm.historyReadOnly
              ? {
                  key: "cell(preview)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goAppointment(data.item.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("seeappointment-btn")))]
                      ),
                      _vm._v(" "),
                      _vm.stacked ? _c("hr") : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16b9569f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b9569f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AppointmentHistory.vue
// module id = 2761
// module chunks = 31 34 47 147